import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { RegionsPage } from '@/pages/dictionaries/RegionsPage'

export const Route = createFileRoute('/dictionaries/regions')({
  component: () => (
    <RequirePermission section="dictionaries" action="view">
      <RegionsPage />
    </RequirePermission>
  ),
})
